import { render, staticRenderFns } from "./ClienteDomicilioInfoIndex.vue?vue&type=template&id=5ab40f98&scoped=true"
import script from "./ClienteDomicilioInfoIndex.vue?vue&type=script&lang=js"
export * from "./ClienteDomicilioInfoIndex.vue?vue&type=script&lang=js"
import style0 from "./ClienteDomicilioInfoIndex.vue?vue&type=style&index=0&id=5ab40f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab40f98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanelContent})
